import React, {useState} from 'react';
import {ArrowPosition, MenuItem, Popover} from '@bosch/react-frok';
import {t} from 'i18next';
import {AddButton, PopoverMenuWrapper} from './AddItemMenu.style';

export interface AddItemDialogProps {
    onCreateFolderClicked: () => void;
    onUploadFileClicked: () => void;
}

/**
 * @name AddItemMenu
 * @description
 * Component to open a popover in the search/filter bar to add files or folders when click on add (+).
 */
export const AddItemMenu: React.VFC<AddItemDialogProps> = (props) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <PopoverMenuWrapper>
            <Popover
                open={open}
                content={
                    <ul className='a-list o-context-menu__menuItems'>
                        <MenuItem
                            key='folder'
                            icon='folder-open'
                            label={t('ADD_ITEM_MENU_COMPONENT_FOLDER_LABEL')}
                            onClick={() => {
                                setOpen(false);
                                props.onCreateFolderClicked();
                            }}
                        />
                        <MenuItem
                            key='file'
                            icon='document'
                            label={t('ADD_ITEM_MENU_COMPONENT_FILE_LABEL')}
                            onClick={() => {
                                setOpen(false);
                                props.onUploadFileClicked();
                            }}
                        />
                    </ul>
                }
                position={ArrowPosition.BOTTOM_CENTER}
                onOutsideClick={() => setOpen(false)}
                onTriggerClick={() => setOpen(true)}
                trigger={<AddButton key='add' icon='add' mode='secondary'/>}
            />
        </PopoverMenuWrapper>
    );
};
